import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("bePracticeInterview", {
  launch: () => ({
    queryKey: ["launch"],
  }),
})
